import { vehicleCategoriesSlice } from "./vehicleCategoriesSlice";
import * as actions from "./vehicleCategoriesActions";
import * as selectors from "./vehicleCategoriesSelectors";

export { actions };
export { selectors };
export default vehicleCategoriesSlice.reducer;
